import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Title = styled.div`
  font-weight: 100;
  font-size: 24px;
  margin: 0 23px;
  margin-bottom: 10px;
  color: ${COLORS.BODY_TEXT};
  border-bottom: 2px solid #666;
  padding: 15px 0;
  display: flex;
  justify-content: space-between;
`;

const TableWrapper = styled.div`
  margin: 20px 0;
`;

const Header = styled.div`
  margin: 20px 0;
  display: flex;
  justify-content: flex-end;
  grid-gap: 20px;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const Button = styled.button`
  cursor: pointer;
  background: #000;
  color: #fff;
  border: none;
  font-weight: bold;
  padding: 10px;
`;

const FileName = styled.div`
  border: 1px solid #000;
  text-align: center;
  min-height: 35;
  line-height: 2.5;
  width: 200;
  font-size: 12;
  padding: 0 10px;
`;

const RefundableAmount = styled.div`
  font-weight: bold;
  font-size: 18px;
  text-align: right;
  width: 100%;
`;

export {
  Title,
  TableWrapper,
  Header,
  Button,
  FileName,
  ButtonWrapper,
  RefundableAmount,
};
